import { render, staticRenderFns } from "./rightSelectDialog.vue?vue&type=template&id=354417a6&scoped=true&"
import script from "./rightSelectDialog.vue?vue&type=script&lang=js&"
export * from "./rightSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./rightSelectDialog.vue?vue&type=style&index=0&id=354417a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354417a6",
  null
  
)

export default component.exports